import { LEADS_INITIAL_STATE, GET_ALL_LEADS_API } from './constants';

export function Reducer(state = LEADS_INITIAL_STATE, action) {
  switch (action.type) {
    case GET_ALL_LEADS_API.REQUEST:
      return { ...state, isFetching: true };
    case GET_ALL_LEADS_API.SUCCESS:
      return {
        ...state,
        leadsList: action.data,
        isFetching: false,
      };
    case GET_ALL_LEADS_API.FAILURE:
      return { ...state, isFetching: false };
    default:
      return state;
  }
}
